// extracted by mini-css-extract-plugin
var _1 = "_viewSerialNoModal-module__container";
export { _1 as "container" }
